import moment from 'moment';

/**
 *  Date Formatter
 *
 *  @param date {any valid date value}
 *  @param format {string}
 */

export const DateFormatter = (date, format = 'YYYY-MM-DD') =>
  moment(date).format(format);
export const Date12AMFormatter = (date, format = 'MM-DD-YYYY') => {
  let time = moment.utc(date);
  const subtractedTime = time.subtract(1, 'second');
  const end = time.clone().endOf('day');

  if (
    subtractedTime.isSame(end, 'hour') &&
    subtractedTime.isSame(end, 'minute') &&
    subtractedTime.isSame(end, 'second')
  ) {
    time = time.add(1, 'hour');
  }

  return time.format(format);
};
